export default "__VITE_ASSET__3hpHcngX__"